import { OwnedObject, invalidateOwner } from 'gear';

import { Xml } from '../util';

// Process
//====================================================================================================

export const Process = OwnedObject.extend({ typeName: 'Process', __debugProps: true,

  Properties:{
    name: { type: 'string', def: null, dropDef:true }
  },

  requiresText() {
    return false;
  },
  outputsText() {
    return false;
  },

  invalidate: invalidateOwner,

  buildXml( parentNode ) {
    Xml.addObject(parentNode,this,this.type);
  },
  setupXml( node ) {
    Xml.setupProperties(node,this);
  },

  canTarget( figure ) {
    return ! ( this.requiresText() && ! ( figure.isText && ! figure.isMultiPart ) ) ;
  },

  canProcess( /*figure*/) {
    return false;
  },

  getColors( colors = [] ) {
    if( 'brush' in this ) {
      this.brush.getColors(colors);
    }
    if( 'pen' in this ) {
      this.pen.getColors(colors);
    }
    return colors;
  },
  getPens( pens = [] ) {
    if( 'pen' in this ) {
      pens.push(this.pen);
    }
    return pens;
  },
  getBrushes( brushes = [] ) {
    if( 'brush' in this ) {
      brushes.push(this.brush);
    }
    return brushes;
  }
});
Process.invalidate = invalidateOwner;

Process.parseXml = function( node ) {
  const processName = node.nodeName;
  const ProcessType = Process[processName];
  if( ProcessType ) {
    return ProcessType.parseXml(node);
  }
  else {
    return null ;
  }
};

Xml.Parser['Process'] = Xml.makeObjectParser(Process);



/** WEBPACK FOOTER **
 ** ./src/cdl/process/process.js
 **/